import { IFetchPendenciesDTO } from 'modules/customer/domain/dtos';
import { IPendenciesRepository } from 'modules/customer/domain/repositories';

export class FetchPendenciesUseCase {
  constructor(private pendenciesRepository: IPendenciesRepository) {}

  public execute({ enterpriseId, customerId }: IFetchPendenciesDTO) {
    return this.pendenciesRepository.findAll({
      enterpriseId,
      customerId,
    });
  }
}
